import Blockbrief from '../configs/quote/blockbrief'

const BLOCKBRIEF = new Blockbrief();

export default class AddProductsService {

  addPackageToCart(packageKey, serviceType){
    let friendlyName = this.props.match.params.friendly_name
    let productId = this.props.product.productsByFriendlyName[friendlyName]
    var configurationBlob = {}
    if(serviceType === 'Blockbrief'){
      configurationBlob = BLOCKBRIEF.defaultConfig(packageKey, productId)
    } else if(serviceType === 'ReportBundle') {
      configurationBlob = {
        configuration:{
          package: packageKey,
          geography:{
            states: null
          },
          product_id: productId
        }
      }
    } else if(packageKey === 'basic1UN'){
      configurationBlob = {
        configuration:{
          package: packageKey,
          number_of_users: 1,
          addons:[],
          geography:{
            national:true,
            states:[]
          },
          product_id: productId,
          industry: "property_developers_trades_services"
        }
      }
    }


    var cartItem = {
      configuration: configurationBlob.configuration,
      product_id: productId

    }
    if(this.props.order && this.props.order !== null && Object.keys(this.props.order).length>0){
      this.props.deleteOrder(cartItem)
    }else{
      this.props.setPackage(null, packageKey, this.props.match.params.friendly_name)
      this.props.saveCartItem(cartItem)
    }
  }

}
